import PropTypes from "prop-types";
import styles from "./DebicheckMandate.module.scss";
import labels from "../../../config/labels";
import formStyles from "../../atoms/staticForms/StaticForms.module.scss";
import { CustomContainer, Form } from "../../atoms/DependencyHelper";

const DebicheckMandate = ({
  onChangeHandler,
  isCheckedState,
  multicartFlag,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event);
  };

  return (
    <CustomContainer
      className={`${formStyles["main-container"]} ${styles["debi_mandate_container"]}`}
    >
      <Form.Row
        className={`${formStyles["main-row"]} ${formStyles["checkbox-row"]} ${formStyles["full-row"]}`}
      >
        <CustomContainer className={`${styles["debi_mandate_head"]}`}>
          <svg
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.94565 4.21714L13.3832 2.33136C13.4607 2.31403 13.5412 2.31403 13.6187 2.33136L22.0562 4.21714C22.303 4.27229 22.4784 4.49129 22.4784 4.74414V15.6173C22.4784 16.6193 21.9753 17.5631 20.849 19.0451C20.0773 20.0657 18.9964 21.0946 17.6371 22.1057C15.927 23.3789 14.5834 24.2829 13.7484 24.7133C13.593 24.7934 13.4085 24.7934 13.2532 24.7132C12.4228 24.2844 11.0822 23.3841 9.36289 22.11C7.99952 21.086 6.92138 20.0612 6.15225 19.0518C5.03121 17.5767 4.52344 16.6204 4.52344 15.6173V4.74414C4.52344 4.49129 4.69889 4.27229 4.94565 4.21714ZM16.4371 9.02482C16.0617 7.71473 14.8637 6.81186 13.5009 6.81186C12.1381 6.81186 10.9402 7.71473 10.5647 9.02482C10.2252 10.2096 10.6327 11.4682 11.5688 12.232L10.458 17.543C10.4529 17.5671 10.4496 17.5916 10.4478 17.6162C10.4194 18.0268 10.5687 18.4299 10.8578 18.7228C11.1429 19.0118 11.537 19.1663 11.9421 19.1484H15.0593C15.463 19.165 15.8554 19.011 16.1401 18.7237C16.4286 18.4327 16.5792 18.0325 16.5543 17.6235C16.5524 17.5926 16.5479 17.5619 16.5408 17.5318L15.929 14.95L15.4261 12.2377C16.3671 11.4745 16.7775 10.2126 16.4371 9.02482ZM15.373 17.9634C15.3011 18.036 15.2017 18.0744 15.0997 18.0691L15.0717 18.0684H11.9287L11.8986 18.0692C11.797 18.0749 11.6979 18.0367 11.6265 17.9643C11.5618 17.8987 11.5255 17.8109 11.5244 17.7195L12.6978 12.1095C12.7441 11.8879 12.6473 11.6609 12.4552 11.5409C11.708 11.0744 11.3602 10.1692 11.6029 9.32234C11.8456 8.47548 12.62 7.89186 13.5009 7.89186C14.3819 7.89186 15.1562 8.47548 15.3989 9.32234C15.6416 10.1692 15.2939 11.0744 14.5466 11.5409C14.3583 11.6585 14.2612 11.8793 14.3017 12.0975L14.8726 15.173L15.4767 17.7252C15.4731 17.8143 15.4364 17.8995 15.373 17.9634Z"
              fill="#333333"
            />
            <mask
              id="Debi_mandate_mask"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="4"
              y="2"
              width="19"
              height="23"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.94565 4.21714L13.3832 2.33136C13.4607 2.31403 13.5412 2.31403 13.6187 2.33136L22.0562 4.21714C22.303 4.27229 22.4784 4.49129 22.4784 4.74414V15.6173C22.4784 16.6193 21.9753 17.5631 20.849 19.0451C20.0773 20.0657 18.9964 21.0946 17.6371 22.1057C15.927 23.3789 14.5834 24.2829 13.7484 24.7133C13.593 24.7934 13.4085 24.7934 13.2532 24.7132C12.4228 24.2844 11.0822 23.3841 9.36289 22.11C7.99952 21.086 6.92138 20.0612 6.15225 19.0518C5.03121 17.5767 4.52344 16.6204 4.52344 15.6173V4.74414C4.52344 4.49129 4.69889 4.27229 4.94565 4.21714ZM16.4371 9.02482C16.0617 7.71473 14.8637 6.81186 13.5009 6.81186C12.1381 6.81186 10.9402 7.71473 10.5647 9.02482C10.2252 10.2096 10.6327 11.4682 11.5688 12.232L10.458 17.543C10.4529 17.5671 10.4496 17.5916 10.4478 17.6162C10.4194 18.0268 10.5687 18.4299 10.8578 18.7228C11.1429 19.0118 11.537 19.1663 11.9421 19.1484H15.0593C15.463 19.165 15.8554 19.011 16.1401 18.7237C16.4286 18.4327 16.5792 18.0325 16.5543 17.6235C16.5524 17.5926 16.5479 17.5619 16.5408 17.5318L15.929 14.95L15.4261 12.2377C16.3671 11.4745 16.7775 10.2126 16.4371 9.02482ZM15.373 17.9634C15.3011 18.036 15.2017 18.0744 15.0997 18.0691L15.0717 18.0684H11.9287L11.8986 18.0692C11.797 18.0749 11.6979 18.0367 11.6265 17.9643C11.5618 17.8987 11.5255 17.8109 11.5244 17.7195L12.6978 12.1095C12.7441 11.8879 12.6473 11.6609 12.4552 11.5409C11.708 11.0744 11.3602 10.1692 11.6029 9.32234C11.8456 8.47548 12.62 7.89186 13.5009 7.89186C14.3819 7.89186 15.1562 8.47548 15.3989 9.32234C15.6416 10.1692 15.2939 11.0744 14.5466 11.5409C14.3583 11.6585 14.2612 11.8793 14.3017 12.0975L14.8726 15.173L15.4767 17.7252C15.4731 17.8143 15.4364 17.8995 15.373 17.9634Z"
                fill="white"
              />
            </mask>
            <g mask="url(#Debi_mandate_mask)">
              <rect y="0.0449219" width="27" height="27" fill="#282828" />
            </g>
          </svg>

          <span className={`${styles["debi_mandate_head_main"]}`}>
            DebiCheck
          </span>

          <span className={`${styles["debi_mandate_head_minor"]}`}>
            (Optional)
          </span>
        </CustomContainer>

        <CustomContainer className={`${styles["debi_mandate_info"]}`}>
          {multicartFlag
            ? labels.creditCheckout.lbl_debicheck_mandate_multicart
            : labels.creditCheckout.lbl_debicheck_mandate}
        </CustomContainer>

        <Form.Group className={`${styles["debi_mandate_check_container"]}`}>
          <Form.Check
            custom
            className={`${formStyles["form-checkbox-label"]}`}
            id={`debicheck_mandate_check`}
          >
            <Form.Check.Input
              name="debiCheckFlag"
              type="checkbox"
              onChange={handleChange}
              checked={isCheckedState}
            />

            <Form.Check.Label id={`debicheck_mandate_check-label`}>
              <span>I would like Vodacom to perform a DebiCheck.</span>
            </Form.Check.Label>
          </Form.Check>
        </Form.Group>
      </Form.Row>
    </CustomContainer>
  );
};

DebicheckMandate.propTypes = {
  onChangeHandler: PropTypes.func,
  isCheckedState: PropTypes.bool,
};

export default DebicheckMandate;
